<template>
  <d-container fluid class="main-content-container px-0">
    <calendar />

    <div :class="{ 'content-overlay': true, 'is-visible': contentOverlayVisible }">
      <div class="content-overlay-wrapper">
        <router-view :key="'subview-' + $route.fullPath" />
      </div>
    </div>
  </d-container>
</template>

<script>
import Calendar from './../components/calendar/Calendar.vue';

export default {
  name: 'dashboard',
  components: {
    'calendar': Calendar
  },
  computed: {
    contentOverlayVisible () {
      return !!this.$route.meta.popup;
    }
  },
  watch: {
    contentOverlayVisible (newValue) {
      if (newValue) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }
  },
  mounted () {
    if (this.$route.meta.popup) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
};
</script>

<style lang="scss" scoped>
.content-overlay {
  background: var(--light-bg);
  height: 100%;
  left: 0;
  opacity: 0;
  overflow: auto;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: all .3s ease-out;
  width: 100%;
  z-index: 201;

  &.is-visible {
    opacity: 1;
    pointer-events: auto;
  }

  &-wrapper {
    margin: 0 auto;
    max-width: 1180px;
    padding: 40px 0;
    width: 100%;
  }
}
</style>
